import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { emptyFunc } from '../../../../helpers/common';
import { propBool } from '../../../../helpers/custom-prop-types';
const ProfessionalUnitCompanySubscribeButtonInner = (props) => {
    const { checked } = props;
    return (_jsx("span", Object.assign({ className: 'subscribe_inner field' }, { children: _jsxs("label", Object.assign({ className: 'pointer' }, { children: [_jsxs("span", Object.assign({ className: 'checkbox_wrapper' }, { children: [_jsx("input", { checked: checked, className: 'subscribe_checkbox', onChange: emptyFunc, type: 'checkbox' }), _jsx("i", {})] })), _jsx("span", { children: "\u6700\u65B0\u60C5\u5831\u3092\u30E1\u30FC\u30EB\u3067\u53D7\u3051\u53D6\u308B" })] })) })));
};
ProfessionalUnitCompanySubscribeButtonInner.propTypes = {
    checked: propBool().isRequired,
};
export default ProfessionalUnitCompanySubscribeButtonInner;
